var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.72214C21 12.1428 17.7248 14.9158 13.6847 14.9158C9.64451 14.9158 6.36902 12.1428 6.36902 8.72214C6.36902 5.3015 9.24433 2.528 13.6847 2.528C14.6943 2.528 15.7711 2.85447 16.0836 2.88883L19.2311 1L18.1312 3.81283C19.8726 4.94414 21 6.71945 21 8.72214Z",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.67607C1 6.25509 4.27516 3.48242 8.31566 3.48242C12.3562 3.48242 15.631 6.25509 15.631 9.67607C15.631 13.0971 12.7557 15.8697 8.31566 15.8697C7.30566 15.8697 6.22893 15.5436 5.91638 15.5087L2.53981 17.5977L3.86883 14.5864C2.12751 13.4541 1 11.6786 1 9.67607Z",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/collaboration.b3bb7fc65214fc6273d73bac71fab628.svg";
export { ForwardRef as ReactComponent };